.section {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.header {
  gap: 16px;
}

.toggle {
  flex-shrink: 0;
}

.sectionTitle {
  margin: 0 0 4px;

  @include themify($themes) {
    color: themed("font_primary");
  }
}

.description {
  margin: 0 0 12px;
  font-size: 13px;
  line-height: 16px;

  @include themify($themes) {
    color: themed("neutral-primary");
  }
}

.status {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 0 0 12px;
  font-size: 12px;

  @include themify($themes) {
    color: themed("neutral-primary");
  }
}

.statusLine {
  line-height: 16px;
}

.statusError {
  line-height: 16px;

  @include themify($themes) {
    color: themed("error-primary");
  }
}
